import type { CognitoUser } from '#lib/websites/news/types.js';
import { loadNewsAuth } from '#lib/websites/news/utils/loadNewsAuth/loadNewsAuth.js';

/**
 * Assembles the news `CognitoUser` from Amplify v6's three separate calls.
 *
 * v5 returned identity, attributes and the session as a single object; v6 splits
 * them, so every caller that needs a logged-in user would otherwise repeat this
 * three-call dance. Throws when there is no signed-in user, matching the v5
 * `currentAuthenticatedUser()` contract the callers already handle.
 */
export const loadCognitoUser = async (): Promise<CognitoUser> => {
	const { fetchAuthSession, fetchUserAttributes, getCurrentUser } =
		await loadNewsAuth();
	const [{ username }, attributes, session] = await Promise.all([
		getCurrentUser(),
		fetchUserAttributes(),
		fetchAuthSession(),
	]);

	return {
		username,
		attributes: { email: attributes.email || '' },
		signInUserSession: {
			accessToken: {
				jwtToken: session.tokens?.accessToken?.toString() || '',
			},
		},
	};
};
